import Auth from 'app/scripts/db/auth.coffee';

export async function memberTokenIsCurrent(): Promise<boolean> | never {
  if (!Auth.isLoggedIn()) {
    return true;
  }

  const response: Response = await fetch(`/1/members/me`);
  if (response.ok) {
    return true;
  }

  if (response.status === 401) {
    return false;
  }

  throw new Error(
    `Could not check member token status. (status: ${response.status}, statusText: ${response.statusText})`,
  );
}
